<section>
  <div class="container-fluid py-4 px-4">

    <div class="container-fluid container-card mb-4">
      <h1 class="heading-1">Office Lease Statistics</h1>

      <div class="row">
        <div class="col-12 col-md-12 col-lg-4"> <!--TW20250924-->
          <div class="card card-occupancy">
            <div class="card-body card-body-custom">
              <h5 class="card-title card-title-custom">
                <img src="assets/icons/occupancy-lease.png"> Occupancy
              </h5>
              
              <div class="container-fluid container-box-progress" *ngIf="ItemsOccupancy">
                <div class="row">
                  <!-- Header dengan master toggle -->
                  <div class="row header-row" (click)="toggleExpand(0)" style="cursor: pointer;">
                    <div class="col-5 title-text">
                      {{ ItemsOccupancy.name }}
                      <i class="fas ms-2" [class.fa-chevron-down]="!expandedStates[0]" [class.fa-chevron-up]="expandedStates[0]"></i>
                    </div>
                    <div class="col-7 total-text">{{ ItemsOccupancy.total_pct}}%</div>
                  </div>
                  <!-- Last Month Section -->
                  <div class="metric-group">
                    <div class="remarks-text">{{ ItemsOccupancy.lm_remarks }}</div>
                    <div class="percentage-value-wrapper">
                      <span class="percentage-text" [class]="getPercentageClass(ItemsOccupancy.pct_lm)">
                        {{ ItemsOccupancy.pct_lm }}%
                      </span>
                      <span class="value-text">{{ ItemsOccupancy.last_month}}%</span>
                    </div>
                  </div>
                  <!-- Budget Section (selalu tampil) -->
                  <!--<div class="metric-group">
                    <div class="remarks-text">{{ ItemsOccupancy.remarks }}</div>
                    <div class="percentage-value-wrapper">
                      <span class="percentage-text" [class]="getPercentageClass(ItemsOccupancy.budget)">
                        {{ ItemsOccupancy.budget }}%
                      </span>
                      <span class="value-text">{{ ItemsOccupancy.from_budget }}%</span>
                    </div>
                  </div>-->
                  
                  <!-- Expandable Sections (hanya tampil jika Total di-expand) -->
                  <div *ngIf="expandedStates[0]">
                    <!-- Last Year Section -->
                    <div class="metric-group">
                      <div class="remarks-text">{{ ItemsOccupancy.ly_remarks }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="percentage-text" [class]="getPercentageClass(ItemsOccupancy.pct_ly)">
                          {{ ItemsOccupancy.pct_ly }}%
                        </span>
                        <span class="value-text">{{ ItemsOccupancy.last_year}}%</span>
                      </div>
                    </div>

                    <!-- This Year Section -->
                    <!--<div class="metric-group last-group">
                      <div class="remarks-text">{{ ItemsOccupancy.ty_remarks }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="percentage-text" [class]="getPercentageClass(ItemsOccupancy.pct_ty)">
                          {{ ItemsOccupancy.pct_ty }}%
                        </span>
                        <span class="value-text">{{ ItemsOccupancy.this_year}}%</span>
                      </div>
                    </div>-->
                  </div>  
                </div>
              </div>

              <div class="card-body">
                <div class="chart-wrapper">
                  <div class="chart-container">
                    <div id="chart">
                      <div *ngIf="isLoadingOccupancy" class="text-center p-4">
                        <div class="spinner-border" role="status">
                          <span class="visually-hidden">Loading occupancy data...</span>
                        </div>
                      </div>

                      <apx-chart *ngIf="!isLoadingOccupancy" [series]="chartOptions.series" 
                        [chart]="chartOptions.chart" [dataLabels]="chartOptions.dataLabels" 
                        [plotOptions]="chartOptions.plotOptions" [yaxis]="chartOptions.yaxis" 
                        [xaxis]="chartOptions.xaxis" [legend]="chartOptions.legend"
                        [colors]="chartOptions.colors" [grid]="chartOptions.grid">
                      </apx-chart>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>

        <div class="col-12 col-md-12 col-lg-2 my-4 my-lg-0">

          <div class="card card-tenant" [routerLink]="['/office-lease/tenant-list']"
            routerLinkActive="router-link-active">
            <div class="card-header">
              <h5 class="card-title card-title-custom">
                <img src="assets/icons/tenant.png"> Tenant
              </h5>
            </div>
            <div class="card-body card-body-custom">

              <div class="tenant-arrow">
                <img src="assets/icons/arrow-top-right.png" alt="">
              </div>

              <div class="container box-tenant-count h-100">
                <h5 class="text-tenant-count text-center">{{ ItemsTenant.totalTenant }}</h5>
              </div>
            </div>
            <div class="card-footer">
              <div class="row mt-5">
                <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-start">
                  <div class="form-group">
                    <h5 class="text-tenant-group">Group</h5>
                  </div>
                </div>
                <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-end">
                  <div class="form-group">
                    <h5 class="text-group-count">{{ ItemsTenant.totalTenantGroup }}</h5>
                  </div>
                </div>
              </div>

              <div class="row mt-1">
                <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-start">
                  <div class="form-group">
                    <h5 class="text-tenant-group">Non-Group</h5>
                  </div>
                </div>
                <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-end">
                  <div class="form-group">
                    <h5 class="text-group-count">{{ ItemsTenant.totalTenantNonGroup }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="col-12 col-md-12 col-lg-3"> <!--TW20250924-->

          <div class="card card-revenue">
            <div class="card-header">
              <h5 class="card-title card-title-custom">
                <img src="assets/icons/revenue-lease.png"> Revenue
              </h5>
            </div>

            <div class="card-body card-body-custom">
              <div class="container-box-lease" *ngFor="let item of ItemsRevenue">
                <div class="row">
                  <div class="col-6 col-md-6 col-lg-6">
                    <h5 class="title-revenue">{{ item.title }}</h5>
                  </div>
                  <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-end">
                    <h5 class="price-revenue">{{ item.value | rupiah }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="col-12 col-md-12 col-lg-3 my-4 my-lg-0">
          <div class="card card-revenue">
            <div class="card-header">
              <h5 class="card-title card-title-custom">
                <img src="assets/icons/revenue.png"> Sales Activities
              </h5>
            </div>
            
            <div class="container">
              <div class="category-slider-container">
                <div class="category-slider-wrapper">
                  <div class="category-buttons-wrapper">
                    <button class="btn-category-activites" *ngFor="let item of ItemSalesActivites.headers"
                      [class.active]="isCategoryActive(item.label)" (click)="onCategoryClick(item.label)">
                      <span class="title-header-button">{{ item.value }}</span>
                      <span class="title-header-count">{{ item.label }}</span>
                    </button>
                  </div>
                </div>
              </div>    

              <!-- Filter status info -->
              <div class="filter-status-info my-3" *ngIf="selectedFilter">
                <small class="text-muted">
                  <i class="fas fa-filter"></i> {{ getFilterStatusText() }}
                  <button class="btn btn-sm btn-clear" (click)="clearFilter()">
                    <i class="fas fa-times"></i> Clear
                  </button>
                </small>
              </div>

              <!-- Loading indicator -->
              <div class="loading-indicator text-center my-4" *ngIf="isLoading">
                <div class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>

              <div class="container-fluid container-group-sales" *ngIf="!isLoading">

                <!-- Empty state ketika tidak ada data -->
                <div class="empty-state text-center my-5" *ngIf="getDisplayedData().length === 0">
                  <i class="fas fa-inbox fa-3x text-muted mb-3"></i>
                  <h6 class="text-muted">No sales activities found</h6>
                  <p class="text-muted small">
                    <span *ngIf="selectedFilter">Try adjusting your filter or </span>
                    <button class="btn btn-link p-0" (click)="clearFilter()" *ngIf="selectedFilter">
                      view all activities
                    </button>
                  </p>
                </div>

                <!-- Loop melalui data yang sudah di-limit -->
                <div class="container-box-group-sales my-3" *ngFor="let item of getDisplayedData()">
                  <div class="row">
                    <div class="col-6 col-md-6 col-lg-6">

                      <div [ngSwitch]="true">
                        <span *ngSwitchCase="item.sales_status === 'Hand Over'" class="badge-handover">{{ item.sales_status
                          }}</span>
                        <span *ngSwitchCase="item.sales_status === 'Won'" class="badge-won">{{
                          item.sales_status }}</span>
                        <span *ngSwitchCase="item.sales_status === 'Inquiry'" class="badge-inquiry">{{ item.sales_status
                          }}</span>
                        <span *ngSwitchCase="item.sales_status === 'Lost'" class="badge-lost">{{
                          item.sales_status
                          }}</span>
                        <span *ngSwitchDefault>{{ item.sales_status }}</span>
                      </div>
                      <div class="mt-2">
                        <h5 class="title-name-activity">{{ item.name }}</h5>
                        <h5 class="title-activity-currency">{{ item.amount | rupiah }}</h5>
                      </div>
                    </div>
                    <div class="col-6 col-md-6 col-lg-6 d-flex align-items-center justify-content-end">
                      <span class="title-date-activity">{{ item.trans_date | dateformat }}</span>
                    </div>
                  </div>
                </div>

              </div>

            </div>

          </div>
          

        </div>
      </div>
    </div>

    <div class="container-fluid container-card">
      <div class="row">
        <div class="col-12 col-md-12 col-lg-6">
          <h1 class="heading-1">Lease Office List</h1>
        </div>
        <div class="col-12 col-md-12 col-lg-6">
          <div class="form-group group-input">
            <input type="text" class="form-control" placeholder="Type Building Name or Tenant Name"
              [(ngModel)]="searchTerm" (keyup)="onSearch($event)">
            <img src="assets/icons/search.png" alt="">
          </div>
        </div>
      </div>

      <div class="table-responsive my-3 p-0 d-none d-lg-block">
        <table class="table table-striped text-nowrap">
          <thead>
            <tr>
              <th class="sortable-header" (click)="onSort('building')">
                <span>Building</span>
                <i [class]="getSortIcon('building')" class="sort-icon"></i>
              </th>
              <th class="text-center">
                Tenant
              </th>
              <th class="text-center sortable-header" (click)="onSort('floor_used')">
                <span>Used Floor</span>
                <i [class]="getSortIcon('floor_used')" class="sort-icon"></i>
              </th>
              <th class="text-center sortable-header" (click)="onSort('floor_available')">
                <span>Available Floor</span>
                <i [class]="getSortIcon('floor_available')" class="sort-icon"></i>
              </th>
              <th class="text-center sortable-header" (click)="onSort('sqm_available')">
                <span>Available SQM</span>
                <i [class]="getSortIcon('sqm_available')" class="sort-icon"></i>
              </th>
              <th>
                Client Type
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody *ngIf="!isLoading && displayedData.length > 0">
            <tr *ngFor="let item of displayedData">
              <td>
                <a [routerLink]="['/office-lease/detail-office-lease', item.id]" routerLinkActive="active">
                  {{ item.building }}
                </a>
              </td>

              <td class="tenant-cell">
                <div class="tenant-display">
                  <!-- Show first 2 tenants only -->
                  <span class="tenant-name">
                    <ng-container *ngIf="item.tenant && item.tenant.length > 0">
                      {{ item.tenant.length === 1 ? item.tenant[0] : (item.tenant[0] + (item.tenant.length > 1 ? ', ' +
                      item.tenant[1] : '')) }}

                      <!-- Show ellipsis if there are more than 2 tenants -->
                      <ng-container *ngIf="item.tenant.length > 2">...</ng-container>
                    </ng-container>
                  </span>

                  <!-- Show info icon only if there are tenants -->
                  <img *ngIf="item.tenant && item.tenant.length > 0" src="assets/icons/info-circle.png"
                    (click)="showTenantDetails(item.tenant, $event)" class="info-icon" alt="View all tenants">
                </div>
              </td>
              <td class="text-center">{{ item.floor_used }}</td>
              <td class="text-center">{{ item.floor_available }}</td>
              <td class="text-center">{{ item.sqm_available | squareMeter }}</td>
              <td>{{ item.client_type }}</td>
              <td><img *ngIf="item.building && item.building.length > 0" src="assets/icon-dashboard-revenue/office.png"
                    (click)="showBuildingGraph(item.id, item.building, $event)" class="info-icon" alt="View Building Graph"></td>
            </tr>

          </tbody>
          <tbody *ngIf="isLoading">
            <tr>
              <td colspan="7" class="text-center">
                <div class="spinner-border text-success" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="my-4 d-block d-lg-none">
        <!---->
        <div class="container">
          <div class="row">
            <div class="col-12 col-md-6" *ngFor="let item of displayedData; let i = index">
              <div class="card card-sm-custom my-3" [ngClass]="{'border bg-light': i % 2 !== 0}">
                <div class="card-body" *ngIf="!isLoading && displayedData.length > 0">
                  
                  <!-- HEADER: Icon Graph di kiri, Building Name di kanan -->
                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <!-- Building Name -->
                    <h5 class="mb-0 text-end">{{ item.building }}</h5>
                  </div>

                  <div class="row">
                    <div class="col-5">
                      <div class="card-sm-title">Tenant</div>
                      <div class="card-sm-title">Used Floor</div>
                      <div class="card-sm-title">Avail. Floor</div>
                      <div class="card-sm-title">Avail. SQM</div>
                      <div class="card-sm-title">Client Type</div>
                      <div class="card-sm-title">Graph</div>
                    </div>
                    <div class="col-7">
                      <div class="card-sm-title">
                        <div class="tenant-display">
                          <span class="tenant-name">
                            <ng-container *ngIf="item.tenant && item.tenant.length > 0">
                              {{ item.tenant[0] | limitText:11 }}
                            </ng-container>
                          </span>
                          <img *ngIf="item.tenant && item.tenant.length > 0" src="assets/icons/info-circle.png"
                            (click)="showTenantDetails(item.tenant, $event)" class="info-icon" alt="View all tenants">
                        </div>
                      </div>
                      <div class="card-sm-title">{{ item.floor_used }}</div>
                      <div class="card-sm-title">{{ item.floor_available }}</div>
                      <div class="card-sm-title">{{ item.sqm_available | squareMeter }}</div>
                      <div class="card-sm-title">{{ item.client_type }}</div>
                      <div class="card-sm-title">
                        <img *ngIf="item.building && item.building.length > 0" src="assets/icon-dashboard-revenue/office.png"
                         (click)="showBuildingGraph(item.id, item.building, $event)" class="info-icon" alt="View Building Graph">
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body d-flex justify-content-center" *ngIf="isLoading">
                  <div class="spinner-border text-success text-center" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12 col-md-12 col-lg-6 d-flex justify-content-center justify-content-lg-start mb-3">
          <div class="pagination-info">
            Displaying
            <span class="fw-bold">{{ displayRange.start | number }}</span> -
            <span class="fw-bold">{{ displayRange.end | number }}</span>
            out of
            <span class="fw-bold">{{ displayRange.total | number }}</span>
          </div>
        </div>
        <div
          class="col-12 col-md-12 col-lg-6 d-flex justify-content-center justify-content-lg-end justify-content-end page-pagination">
          <nav aria-label="Page navigation">
            <ul class="pagination">
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === 1">
                <a class="page-link first-page" href="javascript:void(0)" (click)="onFirstPage()" aria-label="First">
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === 1">
                <a class="page-link prev-page" href="javascript:void(0)" (click)="onPrevPage()" aria-label="Previous">
                  <span aria-hidden="true">&lsaquo;</span>
                </a>
              </li>
              <li class="page-item" *ngFor="let page of pageNumbers"
                [class.active]="page === paginationConfig.currentPage">
                <a class="page-link" href="javascript:void(0)" (click)="onPageChange(page)">{{ page }}</a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === totalPages">
                <a class="page-link next-page" href="javascript:void(0)" (click)="onNextPage()" aria-label="Next">
                  <span aria-hidden="true">&rsaquo;</span>
                </a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === totalPages">
                <a class="page-link last-page" href="javascript:void(0)" (click)="onLastPage()" aria-label="Last">
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>

  </div>


</section>
